import classnames from 'classnames';
import styles from "./ContextMenuCustomContent.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ContextMenuCustomContent({
  children,
  className,
  ...otherProps
}) {
  return /*#__PURE__*/_jsx("div", {
    ...otherProps,
    className: classnames(styles.content, className),
    children: children
  });
}

/**
 * @deprecated This component has been renamed to ContextMenuCustomContent
 */
export const FloatingCustomContent = ContextMenuCustomContent;